import { render } from "./tchildSearch.vue?vue&type=template&id=6416ece0&scoped=true"
import script from "./tchildSearch.vue?vue&type=script&lang=js"
export * from "./tchildSearch.vue?vue&type=script&lang=js"

import "./tchildSearch.vue?vue&type=style&index=0&id=6416ece0&scoped=true&lang=css"

import exportComponent from "D:\\zhang\\项目\\经皮黄疸仪\\jaundiceweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6416ece0"]])

export default __exports__